import React from 'react';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { RetailModelCard } from './RetailModelCard.jsx';
import { NewModelCard } from './NewModelCard.jsx';
import propTypes from 'prop-types';

export function VehicleCard(props) {
  
  const Component = props.retailModel ? RetailModelCard : NewModelCard;
  const block = 'c-vehicle-card';

  const heading = (
    <div className={`${block}__heading-container`}>
      <div className={`${block}__model-name heading`}>{props.modelName}</div>
      <div className={`${block}__description small-text`}>{props.description}</div>
    </div>
  );

  const buttons = (
    <div className={`${block}__buttons-container`}> 
      { props.buttonOneText && <Button label={props.buttonOneText} type='primary' onClickCallback={props.buttonOneOnClickCallback} /> }
      { props.buttonTwoText && <Button label={props.buttonTwoText} type='tertiary' slim={true} onClickCallback={props.buttonTwoOnClickCallback} /> }
    </div>
  );

  return (
    <Component {...props} block={block} heading={heading} buttons={buttons} />
  )
};

VehicleCard.defaultProps = {
  modifierClass: '',
  retailModel: true,
  modelName: 'MDL',
  description: 'CATEGORY DESCRIPTION',
  priceFromText: 'PRICE FROM',
  priceCurrency: '$',
  priceValue: '50,000.00',
  ccisImgConfig: {angle: 9, size: 500, quality: 70},
  imgAltText: 'vehicle side profile',
  backgroundImg: '',
  backgroundColor: '#101010',
  buttonOneText: 'TAKE A CLOSER LOOK',
  buttonOneOnClickCallback: () => { console.log('Button one clicked') },
  buttonTwoOnClickCallback: () => { console.log('Button two clicked') },
  buttonTwoText: 'EXPLORE MODEL',
  imgRotateOn: 'trigger'
};

VehicleCard.propTypes = {
  modifierClass: propTypes.string,
  retailModel: propTypes.bool,
  modelName: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  priceFromText: propTypes.string,
  priceCurrency: propTypes.string,
  priceValue: propTypes.string,
  ccisImgConfig: propTypes.object,
  imgAltText: propTypes.string,
  backgroundImage: propTypes.string,
  backgroundColor: propTypes.string,
  buttonOneText: propTypes.string,
  buttonOneOnClickCallback: propTypes.func,
  buttonTwoOnClickCallback: propTypes.func,
  buttonTwoText: propTypes.string,
  imgRotateOn: propTypes.string,
  imgmgRotationReset: propTypes.bool,
  trackingId: propTypes.string,
};